import * as React from "react"

import { RegisterInner } from "./RegisterInner"

export default class ViolationsHistory extends React.Component {

    render() {

        return <RegisterInner />
    }
}


// WEBPACK FOOTER //
// ./src/Routes/Register/Register.tsx